import React from 'react';
import Button from '@atlaskit/button';
import {
  CopyableText,
  FormattedAddress,
  OpenSidebarButton,
  PricingEligibility,
  SummaryGridItem,
  SummarySection,
  TaxExempt,
  TaxId,
} from '@css-xp/base';
import { CommerceAddress, TransactionAccount } from '@css-xp/graphtypes';
import { EditBillingDetails } from '../sidebar-panels/edit-billing-details-sidebar';
import { SIDEBAR } from '../transaction-account-page';

interface SummaryProps {
  transactionAccountId: string | undefined;
  transactionAccountNumber: string | undefined | null;
  billToPartyPricingEligibilty: string | undefined | null;
  billToAddress: CommerceAddress | undefined | null;
  editBillingDetailsFormProps: EditBillingDetails;
  taxExemptFlag: string;
}

const Summary = ({
  transactionAccountId,
  editBillingDetailsFormProps,
  taxExemptFlag,
  billToPartyPricingEligibilty,
  billToAddress,
  transactionAccountNumber,
}: SummaryProps) => {
  // const taxExemptFlag = billToAddress?.taxExempt ? 'Yes' : 'No';
  // const billToPartyPricingEligibilty = transactionAccount?.billToPartyPricingEligibilty;

  return (
    <SummarySection columns="2fr 1fr" className="transaction-account-summary">
      <SummaryGridItem className="summary-grid-item-internal">
        <SummarySection className="summary-section-internal" columns="1fr 1fr 1fr">
          <SummaryGridItem className="section-item-internal">
            <div>
              {/* className="bill-to-address" */}
              <label>
                {billToAddress && billToAddress.addressLine1 ? 'Bill to address' : 'No address information'}
              </label>
              <div>
                {/* className="address-details" */}
                <FormattedAddress
                  addressLine1={billToAddress?.addressLine1}
                  addressLine2={billToAddress?.addressLine2}
                  city={billToAddress?.city}
                  country={billToAddress?.country}
                  postcode={billToAddress?.postcode}
                  state={billToAddress?.state}
                />
              </div>
              <OpenSidebarButton
                sidebar={SIDEBAR.EDIT_TRANSACTION_ACCOUNT}
                payload={{
                  ...editBillingDetailsFormProps,
                }}
                appearance="link"
                sidebarOptions={{
                  sidebarWidth: '50%',
                  isOverlay: true,
                }}
                testId="edit-transaction-account-action"
                spacing="none"
                label="Edit"
              >
                Edit
              </OpenSidebarButton>
            </div>
          </SummaryGridItem>
          <SummaryGridItem className="section-item-internal">
            <TaxId taxId={billToAddress?.taxId} />
          </SummaryGridItem>
          <SummaryGridItem className="section-item-internal">
            <TaxExempt taxExempt={taxExemptFlag} />
            <Button spacing="none" appearance="link">
              View details
            </Button>
          </SummaryGridItem>
        </SummarySection>
        <SummarySection className="summary-section-internal" columns="1fr 1fr 1fr">
          <SummaryGridItem className="section-item-internal">
            <>
              <label>Billing ID</label>
              <div>{(transactionAccountNumber && <CopyableText text={transactionAccountNumber} />) ?? ''}</div>
            </>
          </SummaryGridItem>
          <SummaryGridItem className="section-item-internal">
            <>
              <label>Billing UUID</label>
              <div>{(transactionAccountId && <CopyableText text={transactionAccountId} />) ?? ''}</div>
            </>
          </SummaryGridItem>
          <SummaryGridItem className="section-item-internal">
            <PricingEligibility plan={billToPartyPricingEligibilty} />
          </SummaryGridItem>
        </SummarySection>
      </SummaryGridItem>

      <SummaryGridItem className="summary-grid-item-internal">
        <label>TODO: payment methods summary</label>
      </SummaryGridItem>
    </SummarySection>
  );
};

export default Summary;
